import { InsuranceFragment, SelectedInsurances } from '@websky/graphql';

export function getSelectedInsuranceSaveCodes(
	insurances: SelectedInsurances[] = [],
	availableInsuranceCodes?: string[]
): string[] {
	if (!insurances.length) {
		return [];
	}

	const selectedSaveServicesCodesSet = new Set<string>();

	insurances.forEach(insurance => {
		const selectedCodes = insurance.selectedPrograms;

		selectedCodes.forEach(code => {
			// filter by available insurance programs
			if (!availableInsuranceCodes?.length || availableInsuranceCodes.includes(code)) {
				selectedSaveServicesCodesSet.add(code);
			}
		});
	});

	return [...selectedSaveServicesCodesSet];
}

export const getImportantInsuranceCodesByAvailableCodes = (
	insurancePrograms: InsuranceFragment,
	availableInsuranceCodes: string[] = []
): string[] => {
	const importantInsuranceCodeSet = new Set<string>();

	insurancePrograms?.insurancePrograms?.forEach(insuranceProgram => {
		if (!insuranceProgram?.code) {
			return;
		}

		if (
			insuranceProgram.important &&
			(!availableInsuranceCodes.length || availableInsuranceCodes.includes(insuranceProgram.code))
		) {
			importantInsuranceCodeSet.add(insuranceProgram.code);
		}
	});

	return [...importantInsuranceCodeSet];
};
